export default function getSectionsFromSelectedItems(
  allItems,
  selectedLibraryItemIds,
  currentSections
) {
  const previouslyLaidOutLibraryItemIds = currentSections
    .flatMap((s) => s.items)
    .map((item) => item.id);
  const currentlyLaidOutItemIds = selectedLibraryItemIds.filter(
    (selectedItemId) => previouslyLaidOutLibraryItemIds.includes(selectedItemId)
  );
  const newNonLaidOutLibraryItemIds = selectedLibraryItemIds.filter(
    (selectedItemId) => !currentlyLaidOutItemIds.includes(selectedItemId)
  );

  const newNonLaidOutLibraryItems = allItems.filter((item) =>
    newNonLaidOutLibraryItemIds.includes(item.id)
  );

  const newSections = currentSections.map((section) => {
    return {
      ...section,
      items: [...section.items, ...newNonLaidOutLibraryItems],
    };
  });

  return {
    nonLaidOutLibraryItems: newNonLaidOutLibraryItems,
    sections: newSections,
  };
}
